module.exports = __webpack_public_path__ + "static/media/icon-outline-power-white.39b79386.svg";